module.exports = __webpack_public_path__ + "img/feiji.5224f9aa.png";